<template>
  <div v-if="payment">
    <div class="title mb-2 text-uppercase">
      {{ $t("transaction_detail_payment.title") }}
    </div>
    <div
      v-for="(payment_transaction, index) in payment.transactions"
      :key="index"
    >
      <div>
        {{ translatePaymentMethod(payment_transaction.payment_method.payment_method) }}
      </div>
      <div v-if="payment_transaction.intention && payment_transaction.payment_method.payment_method == 9">
        <i18n path="transaction_detail_payment.webpay_payment_auth_info" tag="div">
          <span place="auth_code">
            <strong>
              {{ payment_transaction.intention.service_auth_code }}
            </strong>
          </span>
        </i18n>
        <i18n path="transaction_detail_payment.webpay_payment_date" tag="div">
          <span place="payment_date">
            <strong>
              {{ $formatDate(payment_transaction.payment_date) }}
            </strong>
          </span>
        </i18n>
        <i18n path="transaction_detail_payment.webpay_payment_reference" tag="div">
          <span place="payment_reference">
            <strong>
              {{ payment_transaction.intention.uuid }}
            </strong>
          </span>
        </i18n>
        <i18n path="transaction_detail_payment.webpay_payment_amount" tag="div">
          <span place="payment_amount">
            <strong>
              {{ formatMoney(payment_transaction.total, payment_transaction.total_currency) }}
            </strong>
          </span>
        </i18n>
      </div>
      <div v-if="payment_transaction.payment_method.payment_method == 4">
        <div v-if="payment_transaction.service_bank_deposit_reference">
          {{ $t("transaction_detail_payment.bank_transfer.reference") }}:
          {{ payment_transaction.service_bank_deposit_reference }}
        </div>
        <div v-if="payment_transaction.service_bank_deposit_operation_number">
          {{ $t("transaction_detail_payment.bank_transfer.operation_number") }}:
          {{ payment_transaction.service_bank_deposit_operation_number }}
        </div>
        <div v-if="payment_transaction.service_bank_wire_bank_name">
          {{ $t("transaction_detail_payment.bank_transfer.bank_wire_bank_name") }}:
          {{ payment_transaction.service_bank_wire_bank_name }}
        </div>
        <div v-if="payment_transaction.service_bank_wire_account_name">
          {{ $t("transaction_detail_payment.bank_transfer.bank_wire_acount_name") }}:
          {{ payment_transaction.service_bank_wire_account_name }}
        </div>
        <div v-if="payment_transaction.service_bank_wire_number">
          {{ $t("transaction_detail_payment.bank_transfer.bank_wire_number") }}:
          {{ payment_transaction.service_bank_wire_number }}
        </div>
        <div v-if="payment_transaction.service_bank_wire_IBWT">
          {{ $t("transaction_detail_payment.bank_transfer.bank_wire_IBWT") }}:
          {{ payment_transaction.service_bank_wire_IBWT }}
        </div>
        <div v-if="payment_transaction.service_bank_wire_SWIFT">
          {{ $t("transaction_detail_payment.bank_transfer.bank_wire_SWIFT") }}:
          {{ payment_transaction.service_bank_wire_SWIFT }}
        </div>
        <div v-if="payment_transaction.service_bank_wire_CHIPS">
          {{ $t("transaction_detail_payment.bank_transfer.bank_wire_CHIPS") }}:
          {{ payment_transaction.service_bank_wire_CHIPS }}
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import { Money } from "@/lib/money.js";
// Esto tiene sentido porque los índices de los payment aquí están ordenados de
// modo que coincidan con el ID de payment method, 0, 1, 2, 3...
const payment_method_translator = [
  "transaction_detail_payment.payment_method_none",
  "transaction_detail_payment.payment_method_ewallet_paypal",
  "transaction_detail_payment.payment_method_ewallet_openpay",
  "transaction_detail_payment.payment_method_debit_credit_card",
  "transaction_detail_payment.payment_method_bank_transfer",
  "transaction_detail_payment.payment_method_direct_debit",
  "transaction_detail_payment.payment_method_voucher",
  "transaction_detail_payment.payment_method_cash",
  "transaction_detail_payment.payment_method_cash_paynet",
  "transaction_detail_payment.payment_method_webpay",
];

export default {
  name: "transaction-detail-payment",
  props: {
    payment: {
      type: Object,
      default: undefined,
    },
  },
  methods: {
    formatMoney(amount, currency) {
      return new Money(amount, currency).toLocaleString();
    },
    translatePaymentMethod(method) {
      if (!payment_method_translator[method]) {
        return "Unknown";
      }
      return this.$t(payment_method_translator[method]);
    },
  },
  fallbackI18n: {
    messages: {
      und: {
        transaction_detail_payment: {
          title: "Payment info",
          payment_method_none: "None",
          payment_method_ewallet_paypal: "Ewallet paypal",
          payment_method_ewallet_openpay: "Ewallet openpay",
          payment_method_debit_credit_card: "Debit credit card",
          payment_method_bank_transfer: "Bank transfer",
          payment_method_direct_debit: "Direct debit",
          payment_method_voucher: "Voucher",
          payment_method_cash: "Cash",
          payment_method_cash_paynet: "Cash paynet",
          payment_method_webpay: "WebPay Plus",
          webpay_payment_auth_info: "Bank authorization number: {auth_code}",
          webpay_payment_date: "Payment date: {payment_date}",
          webpay_payment_reference: "Payment reference: {payment_reference}",
          webpay_payment_amount: "Payed amount: {payment_amount}",
          bank_transfer: {
            reference: "Reference",
            operation_number: "Operation number",
            concept: "Bank transfer concept",
            bank_wire_number: "Bank wire number",
            bank_wire_bank_name: "Bank name",
            bank_wire_acount_name: "Acount name",
            bank_wire_IBWT: "Bank wire IBWT",
            bank_wire_SWIFT: "Bank wire SWIFT",
            bank_wire_CHIPS: "Bank wire CHIPS",
          },
        },
      },
    },
  },
};
</script>


<style lang="scss" scoped>
.title {
  font-weight: bold;
}
</style>
